// `work.primaryOccupation` is stored as a two-slot array [occupation, position]
// by the backend (see api processOccupation). These helpers read/update the two
// slots without rewriting the stored shape on load: untouched records submit
// verbatim, while an edit always yields a 2-element string array (never holes,
// so compactObject can't drop/reindex a slot on submit).

export function occupationSlots(value: unknown): [string, string] {
  if (Array.isArray(value))
    return [String(value[0] ?? ""), String(value[1] ?? "")];
  if (typeof value === "string") return [value, ""];
  return ["", ""];
}

export function setOccupationSlot(
  current: unknown,
  index: 0 | 1,
  next: string
): [string, string] {
  const slots = occupationSlots(current);
  slots[index] = next;
  return slots;
}
